export default "__VITE_ASSET__9d09a1aa__"